import Immutable from 'immutable';
import { defaultCommunicationObject, updateCommunicationObject } from '~reducers/shared';
import { pendingApprovalActionTypes as actions } from '~constants/actionTypes';

export const defaultState = Immutable.fromJS({
  drafts: [],
  propertyComments: null,
  communication: {
    getList: defaultCommunicationObject,
    getComments: defaultCommunicationObject,
  },
});

const pendingApprovalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actions.SET_PENDING_APPROVAL_LIST: {
      return state.mergeDeep({
        drafts: action.payload.drafts,
      });
    }

    case actions.GET_PENDING_APPROVAL_LIST_CS: {
      return state.mergeDeep({
        communication: {
          getList: updateCommunicationObject(action.status, action.error),
        },
      });
    }

    case actions.SET_PROPERTY_COMMENTS: {
      return state.mergeDeep({
        propertyComments: action.payload,
      });
    }

    case actions.GET_PROPERTY_COMMENTS_CS: {
      return state.mergeDeep({
        communication: {
          getComments: updateCommunicationObject(action.status, action.error),
        },
      });
    }

    default:
      return state;
  }
};

export default pendingApprovalReducer;
